import React from 'react';
import { ButtonGroup } from 'react-bootstrap';
import Button from '../../components/Button';

const buttonGroups = {
  title: 'three buttons mixed',
  buttons: [{
    title: 'btn-tertiary',
    className: 'btn btn-tertiary',
    text: 'btn-tertiary',
    variant: "tertiary"
  }, {
    title: 'btn-secondary 2',
    className: 'btn btn-secondary',
    text: 'btn-secondary',
    variant: "secondary"
  }, {
    title: 'btn-primary',
    className: 'btn btn-primary',
    text: 'btn-primary',
    variant: "primary"
  }]
};

const ButtonGroups = () => (<div className="styles-section row" id="button-groups">
  <div className='main-page-title col-sm-12'>
    <h3>Button Groups</h3>
  </div>
  <div className="col-sm-12 mb-3">
    On desktop, keep the most primary on the right. On mobile, keep the most primary on top.
  </div>
  <div className='home-page-content col-sm-12'>
    <ButtonGroup>
      {
        buttonGroups.buttons.map(button => (
          <Button
            key={button.title}
            variant={button.variant}
            className={button.className}>
            {button.text}
          </Button>
        ))
      }

    </ButtonGroup>
  </div>
</div>);

export default ButtonGroups;